var map = {
	"./abg-0.png": 56481,
	"./abg-1.png": 58198,
	"./abg-1b.png": 48094,
	"./abg-2.png": 42240,
	"./abg-3.png": 35118,
	"./abg-4.png": 36051,
	"./abg-5.png": 75012,
	"./abg-6.png": 94366
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16227;